import { servicesApi } from '@/services/api/deprecated';

// TODO: Only partial interface is implemented, for limited usage
interface Segment {
  id: string;
  tag_ids: string[];
}

interface Tag {
  id: string;
  name: string;
}

interface Segments {
  segments: Segment[];
  tags: Tag[];
}

export const getSegments = async (environmentId: number | string | null) => {
  if (isNaN(parseInt(String(environmentId)))) {
    return null;
  }
  const { data } = await servicesApi.get<Segments>(`/environments/${environmentId}/segments`);

  return data;
};
